import { MessagesSliceActions } from "./messages.store";

export const {
  setMessagesRes,
  addNewMessage,
  resetUnreadCount,
  setMessagesLoadingStatus,
  setMessagesLoadingErrorStatus,
  patchMessage,
  removeTemporaryMessages
} = MessagesSliceActions;
